import "../../styles/styles.scss"
import CheckNok from "../../components/icons/CheckNok";
import { useNavigate } from "react-router-dom";
import routes from "../../routes/routes";
import "../../styles/successPayment.scss"

const PaypalError = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{ height: "100vh" }}
      className="d-flex flex-column align-items-center justify-content-center errorPayment"
    >
      <div>
        <CheckNok width="100" height="auto" color="#e3948b" />
      </div>
      <br />
      <h3 style={{ fontFamily: 'AlteHaasGroteskBold' }}>No se ha podido realizar la transacción.</h3>
      <button className="mt-4 black" type="button" onClick={() => {navigate(routes.coleccion)}}>Volver al shop</button>
    </div>
  );
};

export default PaypalError;
